import requests from "../util";

const { request } = requests;

export const ALL_SOURCES = "all";

const compact = (params = {}) =>
  Object.fromEntries(
    Object.entries(params).filter(
      ([, value]) => value !== undefined && value !== null && value !== ""
    )
  );

const get = (url, params) => request({ url, method: "get", params: compact(params) });
const post = (url, body) => request({ url, method: "post", body });
const patch = (url, body) => request({ url, method: "patch", body });

export const listSourcesForAdmin = () => get("/api/v1/source/admin/listSources");

export const listUsersForAdmin = (params) =>
  get("/api/v1/user/admin/listUsers", params);

export const listBatchesForAdmin = (params) =>
  get("/api/v1/batch/admin/listBatches", params);

export const getBatchDetailsWithSkusForAdmin = (batchId, params) =>
  get(`/api/v1/batch/admin/getBatchDetailsWithSkus/${batchId}`, params);

export const downloadInput = (payload) =>
  post("/api/v1/batch/downloadInput", payload);

export const downloadDeliverable = (payload) =>
  post("/api/v1/batch/downloadDeliverable", payload);

export const resendToSegregation = (payload) =>
  post("/api/v1/work/admin/resendToSegregation", payload);

export const setClientClarificationPending = (payload) =>
  patch("/api/v1/draftSku/admin/setClientClarificationPending", payload);
